export const CREATE_ARTIST = 'ARTIST/CREATE';
export const ADD_MUSIC = 'ARTIST/ADD_MUSIC';
export const LOAD_ARTISTS = 'ARTISTS/LOAD';
export const LOAD_ARTIST = 'ARTIST/LOAD';
export const DELETE_ARTIST = 'ARTIST/DELETE';
export const LOADING_STATUS = 'ARTIST/LOADING_STATUS';
